import { css } from "lit";

export const styles = css`
  .containers {
    height: 100%;
  }

  .live-events-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .section-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    margin: 0;
    color: var(--sds-color-text-default-primary);
    line-height: 20px;
    padding-bottom: var(--sds-size-space-800);
  }

  .upcoming-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 24px;
    color: var(--sds-color-text-default-secondary);
  }

  .events-list {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .delete-confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }

  .delete-confirmation-content p {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }
  .confirmation-buttons {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-300);
  }

  .no-active-events-banner {
    background-color: var(--sds-color-background-default-secondary);
    border-radius: 24px;
  }

  @media (max-width: 768px) {
    .section-title {
      font-size: var(--sds-typography-scale-03);
    }
  }
`;
